import { MultiSelect } from '@/components/ui/multi-select';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { usePlantas } from '@/hooks/usePlantas';
import { nombrePlantaDisplay } from '@/lib/plantas';

interface Props {
  /** `null` = "Todas las plantas". */
  idPlanta: number | null;
  onChange: (idPlanta: number | null) => void;
}

const VALOR_TODAS = '__todas__';

/**
 * Dropdown de plantas activas con opción "Todas". Carga las plantas vía
 * `usePlantas()` con staleTime largo (cambian raramente).
 */
export function FiltroPlanta({ idPlanta, onChange }: Props) {
  const { data, isLoading } = usePlantas();
  const plantas = data?.data?.plantas ?? [];

  const valorActual = idPlanta === null ? VALOR_TODAS : String(idPlanta);

  return (
    <Select
      value={valorActual}
      onValueChange={(v) => {
        onChange(v === VALOR_TODAS ? null : Number(v));
      }}
      disabled={isLoading}
    >
      <SelectTrigger className="w-56">
        <SelectValue placeholder="Cargando plantas…" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={VALOR_TODAS}>Todas las plantas</SelectItem>
        {plantas.map((p) => (
          <SelectItem key={p.id} value={String(p.id)}>
            {nombrePlantaDisplay(p.codigo)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

interface PropsMulti {
  /** `[]` = "Todas las plantas". */
  idsPlanta: number[];
  onChange: (idsPlanta: number[]) => void;
}

/**
 * Igual que `FiltroPlanta` pero de selección múltiple (checkboxes) — usado
 * en el listado de Coladas para poder combinar, ej., Roja + las dos Fiori
 * en un mismo filtro.
 */
export function FiltroPlantaMulti({ idsPlanta, onChange }: PropsMulti) {
  const { data, isLoading } = usePlantas();
  const plantas = data?.data?.plantas ?? [];

  return (
    <MultiSelect
      opciones={plantas.map((p) => ({ value: String(p.id), label: nombrePlantaDisplay(p.codigo) }))}
      seleccionados={idsPlanta.map(String)}
      onChange={(valores) => onChange(valores.map(Number))}
      placeholder={isLoading ? 'Cargando plantas…' : 'Todas las plantas'}
      etiquetaResumen="plantas"
      disabled={isLoading}
    />
  );
}
